import { Component, OnInit } from "@angular/core";
import { RamTargetsService } from "../services/ram-targets/ram-targets.service";
import { RamTargetTurbine } from "../interfaces/ram-targets/ramTargets";
import { TurbineService } from "../services/turbine.service";
import {
  BusinessUnitData,
  MasterData,
} from "../interfaces/ram-targets/masterData";
import { RamTargetsHistoryService } from "../services/ram-targets-history/ram-targets-history";
import { RamTargetHistory } from "../interfaces/ram-targets/ramTargetHistory";
import { CalAngularService } from "@cvx/cal-angular";
import { RamTargetHistoryDto } from "../interfaces/ram-targets/ramTargetHistoryDto";
import { Turbine } from "../interfaces/turbines/turbine.interface";
import * as ExcelJS from "exceljs";

@Component({
    selector: "app-asset-hierarchy",
    templateUrl: "./ram-targets.component.html",
    providers: [RamTargetsService, TurbineService],
    standalone: false
})
export class RamTargetsComponent implements OnInit {
  ramTargetTurbines: RamTargetTurbine[] = [];
  searchRAMTargetTurbines: RamTargetTurbine[] = [];
  ramTargetTurbinesHistory: RamTargetHistory[] = [];
  searchRAMTargetsHistory: RamTargetHistory[] = [];
  editingRow: RamTargetTurbine | null = null;
  editingRowIndex: number | null = null;
  newTargetType: string = "";
  originalRowData: RamTargetTurbine | null = null;
  selectedRecords: RamTargetTurbine[] = [];
  selectedRow: number | null = null;
  isActive: boolean = true;
  isInActive: boolean = false;
  isLoading: boolean = false;
  isLoadingHistory: boolean = false;
  targetList: RamTargetTurbine[] = [];

  masterData: MasterData;
  ramTargetHistoryDto: RamTargetHistoryDto;
  turbineInfo: Turbine | null = null;

  selectedBusinessUnitId: number | null = null;
  selectedOrgId: number | null = null;
  selectedAssetGroupId: number | null = null;
  selectedPlantId: number | null = null;
  selectedMetric: string | null = null;
  selectedMetricId: number | null = null;
  selectedYear: number | null = null;
  selectedYearId: number | null = null;
  selectedTarget: any = null;

  filteredBusinessUnits: BusinessUnitData[] = [];
  filteredAssetGroups: any[] = [];
  filteredPlants: any[] = [];
  filteredMetrics: any[] = [];
  filteredYears: any[] = [];

  searchValuesRAMTarget: { column: string; findValue: string }[] = [];
  searchValuesRAMTargetsHistory: { column: string; findValue: string }[] = [];

  months = [
    { key: "jan", label: "Jan(%)" },
    { key: "feb", label: "Feb(%)" },
    { key: "mar", label: "Mar(%)" },
    { key: "apr", label: "Apr(%)" },
    { key: "may", label: "May(%)" },
    { key: "jun", label: "Jun(%)" },
    { key: "jul", label: "Jul(%)" },
    { key: "aug", label: "Aug(%)" },
    { key: "sep", label: "Sep(%)" },
    { key: "oct", label: "Oct(%)" },
    { key: "nov", label: "Nov(%)" },
    { key: "dec", label: "Dec(%)" },
  ];

  displayedColumns: string[] = [
    "cvxName",
    "targettype",
    ...this.months.map((m) => m.key),
    "comments",
  ];

  groupedData = [];

  onOrganizationChange(orgId: number | null) {
    this.selectedOrgId = orgId;
    this.filteredBusinessUnits = this.masterData.businessUnits.filter(
      (bu) => bu.organizationId === orgId
    );
  }

  onBusinessUnitChange(buId: number | null) {
    this.selectedBusinessUnitId = buId;
    this.filteredAssetGroups = this.masterData.assetGroups.filter(
      (ag) => ag.businessUnitId === buId
    );
  }

  onAssetGroupChange(agId: number | null) {
    this.selectedAssetGroupId = agId;
    this.filteredPlants = this.masterData.plants.filter(
      (p) => p.assetGroupId === agId
    );
  }

  onMetricChange(metricId: number | null) {
    this.selectedMetric =
      this.masterData.metrics.find((m) => m.metricsId === metricId)
        ?.metricsName || null;
    this.selectedMetricId = metricId;
    this.loadRAMTargetData(
      this.selectedPlantId,
      this.selectedMetricId,
      this.selectedYear,
      this.isActive,
      this.isInActive
    );
  }

  onYearChange(yrsId: number | null) {
    this.selectedYearId = yrsId;
    this.selectedYear =
      this.masterData.years.find((year) => year.yearId === yrsId)?.year || null;

    this.loadRAMTargetData(
      this.selectedPlantId,
      this.selectedMetricId,
      this.selectedYear,
      this.isActive,
      this.isInActive
    );
  }

  onPlantChange(plantId: number | null) {
    this.selectedPlantId = plantId;
    this.loadRAMTargetData(
      this.selectedPlantId,
      this.selectedMetricId,
      this.selectedYear,
      this.isActive,
      this.isInActive
    );
  }

  onIsActiveChange(isActive: boolean) {
    this.isActive = isActive;
    this.loadRAMTargetData(
      this.selectedPlantId,
      this.selectedMetricId,
      this.selectedYear,
      this.isActive,
      this.isInActive
    );
  }

  onIsInActiveChange(isInActive: boolean) {
    this.isInActive = isInActive;
    this.loadRAMTargetData(
      this.selectedPlantId,
      this.selectedMetricId,
      this.selectedYear,
      this.isActive,
      this.isInActive
    );
  }

  loadRAMTargetData(
    plantId: number | null,
    metricId: number | null,
    year: number | null,
    isActive: boolean,
    isInActive: boolean
  ) {
    this.isLoading = true;
    this.searchRAMTargetsHistory = [];
    this.ramTargetsService
      .getRamTargetsDataAsync(
        plantId,
        this.masterData.metrics.find((m) => m.metricsId === metricId)
          ?.metricsName,
        year,
        isActive,
        isInActive
      )
      .subscribe((data) => {
        this.ramTargetTurbines = data;
        this.searchRAMTargetTurbines = [...this.ramTargetTurbines];

        this.groupedData = [];
        let lastSerial = null;
        for (const item of this.ramTargetTurbines) {
          if (item.serialNumber !== lastSerial) {
            this.groupedData.push({
              isGroup: true,
              serialNumber: item.serialNumber,
            });
            lastSerial = item.serialNumber;
          }
          this.groupedData.push({ ...item, isGroup: false });
        }
        this.isLoading = false;
      }
      , (error) => {
        this.isLoading = false;
      }
    );
  }

  constructor(
    private ramTargetsService: RamTargetsService,
    private ramTargetsHistoryService: RamTargetsHistoryService,
    private turbineService: TurbineService,
    private authService: CalAngularService
  ) {}

  ngOnInit(): void {
    this.ramTargetsService.getMasterData().subscribe((data) => {
      this.masterData = data;
    });
  }

  onEditRow(target: RamTargetTurbine) {
    if (this.editingRow !== null && this.editingRow !== target) {
      if (
        confirm(
          "Please save or cancel the current edit before editing another record."
        )
      ) {
        return;
      } else {
        return;
      }
    }
    this.editingRow = target;
    this.editingRowIndex = this.searchRAMTargetTurbines.indexOf(target);
    // Deep copy the row data
    this.originalRowData = { ...target };
  }

  saveRAMTargets(editedRow: RamTargetTurbine) {
    editedRow = this.editingRow;
    if (confirm("Are you sure you want to save the changes?")) {
      if (
        editedRow?.id === 0 ||
        editedRow?.id === null ||
        editedRow?.id === undefined
      ) {
        let userInfo = this.authService.getAccount();

        editedRow.id = 0;
        editedRow.year = this.selectedYear;
        editedRow.metric = this.selectedMetric;
        editedRow.rowCreatedBy = userInfo.username;
        editedRow.rowCreatedDate = new Date();
        editedRow.rowUpdatedBy = null;
        editedRow.rowUpdatedDate = null;

        this.ramTargetsService.setRamTarget(editedRow);
        this.ramTargetsService
          .addRamTarget()
          .subscribe((response: RamTargetTurbine) => {
            editedRow.id = response.id; 
            if (this.editingRowIndex !== null) {
              this.ramTargetTurbines[this.editingRowIndex] = editedRow;
            }

            // Insert second new RAM Target
            this.newTargetType = editedRow.targettype;
            if (this.newTargetType === "Planned") {
              this.newTargetType = "Projected";
            } else if (this.newTargetType === "Projected") {
              this.newTargetType = "Planned";
            }
            this.ramTargetsService.setRamTarget(<RamTargetTurbine>(<unknown>{
              id: 0,
              ramTargetsId: editedRow.id,
              turbineId: editedRow.turbineId,
              targettype: this.newTargetType,
              year: this.selectedYear,
              metric: this.selectedMetric,
              jan: 0,
              feb: 0,
              mar: 0,
              apr: 0,
              may: 0,
              jun: 0,
              jul: 0,
              aug: 0,
              sep: 0,
              oct: 0,
              nov: 0,
              dec: 0,
              comments: "",
              rowCreatedBy: userInfo.username,
              rowCreatedDate: new Date(),
            }));

            this.ramTargetsService.addRamTarget().subscribe(
              (response: RamTargetTurbine) => {
                // Insert new RAM Target History
                this.ramTargetsHistoryService.setRamTargetHistory(<
                  RamTargetHistoryDto
                >(<unknown>{
                  ramTargetsId: editedRow.id,
                  turbineId: editedRow.turbineId,
                  targettype: editedRow.targettype,
                  year: this.selectedYear,
                  metric: this.selectedMetric,
                  jan: this.parseDecimal(editedRow.jan),
                  feb: this.parseDecimal(editedRow.feb),
                  mar: this.parseDecimal(editedRow.mar),
                  apr: this.parseDecimal(editedRow.apr),
                  may: this.parseDecimal(editedRow.may),
                  jun: this.parseDecimal(editedRow.jun),
                  jul: this.parseDecimal(editedRow.jul),
                  aug: this.parseDecimal(editedRow.aug),
                  sep: this.parseDecimal(editedRow.sep),
                  oct: this.parseDecimal(editedRow.oct),
                  nov: this.parseDecimal(editedRow.nov),
                  dec: this.parseDecimal(editedRow.dec),
                  comments: editedRow.comments || "",
                  rowCreatedBy: userInfo.username,
                  rowCreatedDate: new Date(),
                }));

                this.ramTargetsHistoryService.addRamTargetHistory().subscribe(
                  (historyResponse) => {
                    // Update the RAM Target History with the edited row
                    this.ramTargetTurbinesHistory.push({
                      ramTargetsId: editedRow.id,
                      turbineID: editedRow.turbineId,
                      serialNumber:
                        editedRow.serialNumber + " - " + editedRow.targettype,
                      cvxName: editedRow.cvxName || null, 
                      targettype: editedRow.targettype,
                      updatedBy: userInfo.username,
                      updatedOn: new Date(),
                      jan: this.parseDecimal(editedRow.jan),
                      feb: this.parseDecimal(editedRow.feb),
                      mar: this.parseDecimal(editedRow.mar),
                      apr: this.parseDecimal(editedRow.apr),
                      may: this.parseDecimal(editedRow.may),
                      jun: this.parseDecimal(editedRow.jun),
                      jul: this.parseDecimal(editedRow.jul),
                      aug: this.parseDecimal(editedRow.aug),
                      sep: this.parseDecimal(editedRow.sep),
                      oct: this.parseDecimal(editedRow.oct),
                      nov: this.parseDecimal(editedRow.nov),
                      dec: this.parseDecimal(editedRow.dec),
                      comments: editedRow.comments || null,
                    });
                  },
                  (error) => {
                    console.error("Error updating RAM Target History:", error);
                  }
                );
              },
              (error) => {
                console.error("Error updating RAM Target:", error);
              }
            );
          });
      } else if (editedRow.id !== 0) {
        let userInfo = this.authService.getAccount();

        this.ramTargetsHistoryService.setRamTargetHistory(<RamTargetHistoryDto>(
          (<unknown>{
            ramTargetsId: editedRow.id,
            turbineId: editedRow.turbineId,
            targettype: editedRow.targettype,
            year: this.selectedYear,
            metric: this.selectedMetric,
            jan: this.parseDecimal(editedRow.jan),
            feb: this.parseDecimal(editedRow.feb),
            mar: this.parseDecimal(editedRow.mar),
            apr: this.parseDecimal(editedRow.apr),
            may: this.parseDecimal(editedRow.may),
            jun: this.parseDecimal(editedRow.jun),
            jul: this.parseDecimal(editedRow.jul),
            aug: this.parseDecimal(editedRow.aug),
            sep: this.parseDecimal(editedRow.sep),
            oct: this.parseDecimal(editedRow.oct),
            nov: this.parseDecimal(editedRow.nov),
            dec: this.parseDecimal(editedRow.dec),
            comments: editedRow.comments || "",
            rowCreatedBy: userInfo.username,
            rowCreatedDate: new Date(),
          })
        ));

        this.ramTargetsHistoryService.addRamTargetHistory().subscribe(
          (response) => {
            if (this.editingRowIndex !== null) {
              this.ramTargetTurbines[this.editingRowIndex] = editedRow;
            }
            // Update the RAM Target History with the edited row
            this.ramTargetTurbinesHistory.push({
              ramTargetsId: editedRow.id,
              turbineID: editedRow.turbineId,
              serialNumber:
                editedRow.serialNumber + " - " + editedRow.targettype,
              targettype: editedRow.targettype,
              updatedBy: userInfo.username,
              updatedOn: new Date(),
              jan: this.parseDecimal(editedRow.jan),
              feb: this.parseDecimal(editedRow.feb),
              mar: this.parseDecimal(editedRow.mar),
              apr: this.parseDecimal(editedRow.apr),
              may: this.parseDecimal(editedRow.may),
              jun: this.parseDecimal(editedRow.jun),
              jul: this.parseDecimal(editedRow.jul),
              aug: this.parseDecimal(editedRow.aug),
              sep: this.parseDecimal(editedRow.sep),
              oct: this.parseDecimal(editedRow.oct),
              nov: this.parseDecimal(editedRow.nov),
              dec: this.parseDecimal(editedRow.dec),
              comments: editedRow.comments || null,
            });

            // Update the original row data
            editedRow.year = this.selectedYear;
            editedRow.metric = this.selectedMetric;
            editedRow.rowCreatedBy =
              editedRow.rowCreatedBy || userInfo.username;
            editedRow.rowCreatedDate = editedRow.rowCreatedDate || new Date();
            editedRow.rowUpdatedBy = userInfo.username;
            editedRow.rowUpdatedDate = new Date();

            //Update RAM Target table
            this.ramTargetsService.updateRamTarget(editedRow).subscribe(
              (updateResponse) => {
              },
              (error) => {
                console.error("Error updating RAM Target:", error);
              }
            );
          },
          (error) => {
            console.error("Error updating RAM Target History:", error);
          }
        );
      }
    } else {
      this.cancelEdit();
    }
    this.editingRow = null;
    this.editingRowIndex = null;
  }

  cancelEdit() {
    if (this.editingRow !== null && this.originalRowData) {
      // Find the index of the editing row object
      // const idx = this.ramTargetTurbines.indexOf(this.editingRow);
      if (this.editingRowIndex !== null) {
        this.ramTargetTurbines[this.editingRowIndex] = {
          ...this.originalRowData,
        };
      }
    }
    this.editingRow = null;
    this.editingRowIndex = null;
    this.originalRowData = null;
  }

  parseDecimal(value: any): number | null {
    return value === "" || value === null ? null : parseFloat(value);
  }

  exportToExcel() {
    const headerRow = [
      "Serial Number",
      "Year",
      "Target Type",
      ...this.months.map(
        (month) => month.key.charAt(0).toUpperCase() + month.key.slice(1)
      ),
    ];
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("RAM_Targets");
    worksheet.addRow(headerRow);
    worksheet.getRow(1).font = {
      bold: true,
      size: 12,
      color: { argb: "000000" },
    };
    worksheet.getRow(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    this.ramTargetTurbines.forEach((item) => {
      const row = [
        item.serialNumber,
        this.selectedYear,
        item.targettype,
        this.parseDecimal(item.jan),
        this.parseDecimal(item.feb),
        this.parseDecimal(item.mar),
        this.parseDecimal(item.apr),
        this.parseDecimal(item.may),
        this.parseDecimal(item.jun),
        this.parseDecimal(item.jul),
        this.parseDecimal(item.aug),
        this.parseDecimal(item.sep),
        this.parseDecimal(item.oct),
        this.parseDecimal(item.nov),
        this.parseDecimal(item.dec),
      ];
      worksheet.addRow(row).eachCell((cell) => {
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: parseInt(cell.col) == 1,
        };
      });
    });
    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 5;
    });
    worksheet.workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "RAM_Targets.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  exportChangeHistoryToExcel() {
    const headerRow = [
      "SERIAL_NUMBER",
      "TARGETTYPE",
      "ROW_CREATED_BY",
      "ROW_CREATED_DATE",
      ...this.months.map(
        (month) => month.key.charAt(0).toUpperCase() + month.key.slice(1)
      ),
      "COMMENTS",
    ];
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("RAM_Targets_History");
    worksheet.addRow(headerRow);
    worksheet.getRow(1).font = {
      bold: true,
      size: 12,
      color: { argb: "000000" },
    };
    worksheet.getRow(1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    this.searchRAMTargetsHistory.forEach((item) => {
      const row = [
        item.serialNumber,
        item.targettype,
        item.updatedBy,
        this.formatDate(item.updatedOn.toString()),
        this.parseDecimal(item.jan),
        this.parseDecimal(item.feb),
        this.parseDecimal(item.mar),
        this.parseDecimal(item.apr),
        this.parseDecimal(item.may),
        this.parseDecimal(item.jun),
        this.parseDecimal(item.jul),
        this.parseDecimal(item.aug),
        this.parseDecimal(item.sep),
        this.parseDecimal(item.oct),
        this.parseDecimal(item.nov),
        this.parseDecimal(item.dec),
        item.comments,
      ];
      worksheet.addRow(row).eachCell((cell) => {
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
        };
      });
    });
    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 10;
    });
    worksheet.workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "RAM_Targets_History.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  onRowClick(target: any) {
    this.isLoadingHistory = true;
    this.selectedTarget = target;
    this.ramTargetsHistoryService
      .getRamTargetsHistoryDataAsync(parseInt(target.id))
      .subscribe((data) => {
        this.ramTargetTurbinesHistory = data;
        this.searchRAMTargetsHistory = [...this.ramTargetTurbinesHistory];
        this.isLoadingHistory = false;
      }
      , (error) => {
        this.isLoadingHistory = false;
      }
    );
    this.selectedRecords = [];
    this.selectedRecords.push(target);
  }

  formatDate(input: string): string {
    const date = new Date(input);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    let hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = Number(hours) >= 12 ? "PM" : "AM";
    hours = (Number(hours) % 12).toString().padStart(2, "0");
    hours = Number(hours) ? hours : "12";
    const strTime = `${hours}:${minutes} ${ampm}`;

    return `${month}/${day}/${year} ${strTime}`;
  }

  searchFilterRAMTarget(columnName: string, event: Event) {
    const filterValue = (event.target as HTMLInputElement).value?.trim() ?? '';

    // Update or remove filter for the column
    const existingIndex = this.searchValuesRAMTarget.findIndex(f => f.column === columnName);
    if (!filterValue) {
      if (existingIndex !== -1) {
        this.searchValuesRAMTarget.splice(existingIndex, 1);
      }
    } else {
      if (existingIndex !== -1) {
        this.searchValuesRAMTarget[existingIndex].findValue = filterValue;
      } else {
        this.searchValuesRAMTarget.push({ column: columnName, findValue: filterValue });
      }
    }

    // Start with all data
    this.searchRAMTargetTurbines = [...this.ramTargetTurbines];

    // Apply all filters
    for (const filter of this.searchValuesRAMTarget) {
      this.searchRAMTargetTurbines = this.searchRAMTargetTurbines.filter(item => {
        const val = item[filter.column]?.toString().toLowerCase() ?? '';
        return val.includes(filter.findValue.toLowerCase());
      });
    }
  }

  searchFilterRAMTargetsHistory(columnName: string, event: Event) {
    const filterValue = (event.target as HTMLInputElement).value?.trim() ?? '';

    // Update or remove filter for the column
    const existingIndex = this.searchValuesRAMTargetsHistory.findIndex(f => f.column === columnName);
    if (!filterValue) {
      if (existingIndex !== -1) {
        this.searchValuesRAMTargetsHistory.splice(existingIndex, 1);
      }
    } else {
      if (existingIndex !== -1) {
        this.searchValuesRAMTargetsHistory[existingIndex].findValue = filterValue;
      } else {
        this.searchValuesRAMTargetsHistory.push({ column: columnName, findValue: filterValue });
      }
    }

    // Start with all data
    this.searchRAMTargetsHistory = [...this.ramTargetTurbinesHistory];

    // Apply all filters
    for (const filter of this.searchValuesRAMTargetsHistory) {
      this.searchRAMTargetsHistory = this.searchRAMTargetsHistory.filter(item => {
        const val = item[filter.column]?.toString().toLowerCase() ?? '';
        return val.includes(filter.findValue.toLowerCase());
      });
    }
  }
}
